import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdminEmailsService } from 'src/app/shared/api/admin-emails.service';
import { LoaderPageModule } from 'src/app/shared/components/loader-page/loader-page.module';
import { CardModule } from '../../shared/components/card/card.module';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { TableListModule } from '../../shared/components/table-list/table-list.module';
import { ToolbarModule } from '../../shared/components/toolbar/toolbar.module';
import { AdminEmailsRoutingModule } from './admin-emails-routing.module';
import { AdminEmailsComponent } from './admin-emails.component';

@NgModule({
    declarations: [AdminEmailsComponent],
    providers: [
        AdminEmailsService
    ],
    imports: [
        CommonModule,
        AdminEmailsRoutingModule,
        TableListModule,
        ToolbarModule,
        CardModule,
        ContainerPadraoModule,
        LoaderPageModule
    ]
})
export class AdminEmailsModule {}
